import React, { useEffect, useState } from 'react'

import './geofences.css';
import GeofenceItem from '../../../components/geofenceItem';
import RouteModal from '../../../components/routeModal';
import { Button } from '@mui/material';
import BootstrapTooltip from '../../../components/tooltip';

const Geofences = ({ geoTags, geofences, userRoute, userUpdate }) => {
  const [filteredGeofences, setFilteredGeofences] = useState([]); // Columna para ordenar
  const [openRouteModal, setOpenRouteModal] = useState(false);

  const [routeOrder, setRouteOrder] = useState(userRoute);
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [isRouteChanged, setIsRouteChanged] = useState(false);

  useEffect(() => {
    // Obtener el id de "Checadas"
    const checadasTag = geoTags.find((item) => item.name === 'Checadas');
    if (checadasTag) {
      const checadasId = checadasTag.id;

      // Filtrar geofences que contengan el id de "Checadas" en sus tags
      const filtered = geofences.filter(
        (geofence) => Array.isArray(geofence.tags) && geofence.tags.includes(checadasId)
      );

      setFilteredGeofences(filtered);
    }
  }, [geoTags, geofences]);

  const handleDragStart = (index) => (event) => {
    event.dataTransfer.setData("text/plain", index);
  };

  const handleDrop = (targetIndex) => (event) => {
    event.preventDefault();
    const sourceIndex = Number(event.dataTransfer.getData("text/plain"));
    if (sourceIndex === targetIndex || sourceIndex < 0 || targetIndex < 0) return;

    const updatedOrder = [...routeOrder];
    const [movedItem] = updatedOrder.splice(sourceIndex, 1);
    updatedOrder.splice(targetIndex, 0, movedItem);
    setRouteOrder(updatedOrder);
    setHoveredIndex(null); // Limpiar estado al soltar

    // Comparar routeOrder con userRoute
    const hasChanged = JSON.stringify(updatedOrder) !== JSON.stringify(userRoute);
    setIsRouteChanged(hasChanged); // Actualiza el estado del botón
  };

  const handleDragOver = (index) => (event) => {
    event.preventDefault();
    setHoveredIndex(index); // Establecer índice sobrevolado
  };

  const handleDragLeave = () => {
    setHoveredIndex(null); // Limpiar índice al salir
  };

  const toggleGeofenceState = (index) => {
    const updatedOrder = routeOrder.map((geofence, i) =>
      i === index ? { ...geofence, state: geofence.state === "activo" ? "omitido" : "activo" } : geofence
    );
    setRouteOrder(updatedOrder);
    setIsRouteChanged(true);
  };

  const handleConfirm = () => {
    userUpdate({ route: routeOrder });
  };

  const handleAngleChange = (index) => (event) => {
    let value = event.target.value;

    if (value === '') {
      value = null;
    } else {
      value = Number(value);
      if (value < 0 || value > 360) return;
    }

    const updatedOrder = routeOrder.map((geofence, i) =>
      i === index ? { ...geofence, orientation: value } : geofence
    );

    setRouteOrder(updatedOrder);
    setIsRouteChanged(true);
  };

  const duplicateGeofence = (index) => {

  const current = routeOrder[index];
  const currentId = current.id;

  let updatedOrder = [...routeOrder];

  // Buscar cuántos hay con ese id
  const sameIdCount =
    routeOrder.filter(item => item.id === currentId).length;

  // CASO 1: HAY MÁS DE UNO → UNIFICAR
  if (sameIdCount > 1) {

    // Quitar todos menos el actual
    updatedOrder = updatedOrder.filter(
      (item, i) => item.id !== currentId || i === index
    );

    // Limpiar nombre por ID (no índice)
    updatedOrder = updatedOrder.map(item => {

      if (item.id === currentId) {
        return {
          ...item,
          label: normalizeLabel(item.label)
        };
      }

      return item;
    });

    setRouteOrder(updatedOrder);
    setIsRouteChanged(true);
    return;
  }

  // CASO 2: SOLO UNO → DUPLICAR

  const baseName = normalizeLabel(current.label);

  const ida = {
    ...current,
    label: `${baseName} Ida`,
  };

  const vuelta = {
    ...current,
    label: `${baseName} Vuelta`,
  };

  updatedOrder.splice(index, 1, ida, vuelta);

  setRouteOrder(updatedOrder);
  setIsRouteChanged(true);
};


  const normalizeLabel = (label) => {
    return label
      .replace(/\s+Ida$/, '')
      .replace(/\s+Vuelta$/, '')
      .trim();
  };


  return (
    <div style={{ display: 'flex', flex: '1', overflowY: 'hidden', gap: '1.5rem' }}>
      <div className='card' style={{ overflowY: 'hidden', display: 'flex', flexDirection: 'column', flex: 1 }}>
        <h2 className='card_title'>Ruta general</h2>
        <div style={{ display: 'flex', gap: '0.5rem', padding: 'calc(0.5rem + 2px)' }}>
          <span style={{ fontSize: '0.75rem', fontStyle: 'italic', flex: 1 }}>Nombre</span>
          <span style={{ fontSize: '0.75rem', fontStyle: 'italic', flexBasis: '70px' }}>Orientación</span>
          <span style={{ fontSize: '0.75rem', fontStyle: 'italic', flexBasis: '100px', textAlign: 'center', marginRight: '3.7rem' }}>Estatus</span>
        </div>
        <div className="route_container">
          {routeOrder.length > 0 ?
            <ul>
              {routeOrder.map((geofence, index) => (
                <li
                  key={`${geofence.id}-${geofence.label}-${index}`}
                  draggable
                  onDragStart={handleDragStart(index)}
                  onDragOver={handleDragOver(index)}
                  onDragLeave={handleDragLeave}
                  onDrop={handleDrop(index)}
                  className={`${hoveredIndex === index ? "hovered" : ""} ${geofence.state === "omitido" ? "omitted" : ""}`}
                  style={{ display: 'flex', gap: '0.5rem' }}
                >
                  <span style={{ fontSize: '0.7rem', flex: 1 }}>{geofence.label}</span>
                  <input
                    id={`geofence-${geofence.id}-${geofence.label}`}
                    type="number"
                    min={0}
                    max={360}
                    value={geofence.orientation ?? 0}
                    onChange={handleAngleChange(index)}
                    onFocus={(e) => e.target.select()}
                    onBlur={(e) => {
                      const val = Number(e.target.value);
                      if (val < 0 || val > 360) {
                        handleAngleChange(index)({ target: { value: '' } });
                      }
                    }}

                    style={{
                      width: '60px',
                      fontSize: '0.7rem',
                      padding: '2px',
                      flexBasis: '70px',
                    }}
                  />
                  <Button onClick={() => toggleGeofenceState(index)} style={{ fontSize: '0.7rem', flexBasis: '100px', }}>
                    {geofence.state === "activo" ? "Omitir" : "Activar"}
                  </Button>
                  {routeOrder.filter(r => r.id === geofence.id).length > 1 ?
                    <BootstrapTooltip
                      title={'Unificar'}
                    >

                      <Button
                        onClick={() => duplicateGeofence(index)}
                        style={{ minWidth: '32px' }}
                      >
                        <span className='material-symbols-rounded icon' style={{ fontSize: '18px', color: 'var(--color-danger)' }}>tab_close_inactive</span>
                      </Button>
                    </BootstrapTooltip>
                    :
                    <BootstrapTooltip
                      title={'Duplicar'}
                    >

                      <Button
                        onClick={() => duplicateGeofence(index)}
                        style={{ minWidth: '32px' }}
                      >
                        <span className='material-symbols-rounded icon' style={{ fontSize: '18px' }}>tab_inactive</span>
                      </Button>
                    </BootstrapTooltip>
                  }
                </li>
              ))}
            </ul>
            :
            <span style={{ margin: 'auto', fontStyle: 'italic' }}>No hay una ruta definida.</span>
          }
        </div>
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button variant="contained" style={{ marginTop: '1rem', fontSize: '0.75rem' }} onClick={handleConfirm} disabled={!isRouteChanged}>
            Guardar Cambios
          </Button>
        </div>
      </div>

      <div className='card' style={{ overflowY: 'hidden', display: 'flex', flexDirection: 'column', flex: 1 }}>
        <h2 className='card_title'>Geocercas encontradas</h2>
        {/* Modificar orden de puntos de control */}
        {filteredGeofences.length > 0 ? (
          <div className='geofences_container'>
            {
              filteredGeofences.map((geofence) => (
                <GeofenceItem key={geofence.id} geofence={geofence} />
              ))
            }
          </div>
        ) : (
          <p>No se encontraron puntos de control para "Checadas".</p>
        )}
      </div>
    </div>
  )
}

export default Geofences